export default class Env {
  static isDevelopment() {
    return window.location.hostname.indexOf('localhost') > -1
  }
  static isStaging() {
    return window.location.hostname.indexOf('stage.fanplayr.com') > -1
  }
  static isProduction() {
    return window.location.hostname.indexOf('portal.fanplayr.com') > -1 || window.location.hostname.indexOf('portal2.fanplayr.com') > -1
  }
}